import React, { useEffect } from "react";
import NavbarPortal from "../../Components/Navbar";
import FooterPortal from "../../Components/Footer";
import AstaCita from "../../Components/Tentang/astacita";

export default function AstaCitaPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="font-signika">
      <NavbarPortal />
      <div className="">
        <AstaCita />
      </div>

      <FooterPortal />
    </div>
  );
}
